import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { filter } from 'rxjs';
import { EcgFileManagementComponent } from 'src/app/modals/ecg-file-management/ecg-file-management.component';
import { ModalApprovedComponent } from 'src/app/modals/modal-approved/modal-approved.component';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MatToolbarModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnInit {
  @Output() valueChanged = new EventEmitter<boolean>();

  isSidebarOpen: boolean = true;
  userInfo: any;
  notification: any[] = [];
  notifyCount: number = 0;
  planType: number = 0;
  showNotifyPanel: boolean = false;
  modalReference!: BsModalRef;
  urlParams: any;
  pageType = 'View';
  ecgView = false;
  showEcgIcon = false;
  routeName: any;
  routerId: any


  constructor(public router: Router, private modalService: BsModalService, public activeRoute: ActivatedRoute,
    private notificationService: NotificationService,
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.routerId = this.activeRoute.snapshot.queryParamMap.get('id');
          this.showEcgIcon =
            event.urlAfterRedirects.includes('patient-form') && !!this.routerId;
        }
      });



    this.routerId = this.activeRoute.snapshot.queryParamMap.get('id');
    this.showEcgIcon =
      this.router.url.includes('patient-form') && !!this.routerId;
  }


  ngOnInit() {
    this.notificationService.init();
    this.loadNotifications();
  }

  loadNotifications() {
    this.notificationService.list().subscribe((response: any) => {
      this.notification = response?.data || [];
      this.notifyCount = response?.unreadCount || 0;
    });
  }

  changeToggle() {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.valueChanged.emit(this.isSidebarOpen);
  }

  logOut() {
    const initialState = {
      icon: 'warning',
      colorCode: 'danger',
      textOne: 'You are about to logout.',
      textTwo: '',
      textThree: 'Are you sure you want to continue?',
    };

    const bsModalRef: BsModalRef = this.modalService.show(ModalApprovedComponent, { initialState });
    bsModalRef.content.onClose.subscribe((result: any) => {
      if (result?.Status === true) {
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/login']);
      }
    });
  }

  viewECG() {
    const initialState = { urlParams: { Patient: this.routerId }, pageType: "edit" };
    // console.log(initialState)
    this.modalReference = this.modalService.show(EcgFileManagementComponent, Object.assign({ initialState }, { ignoreBackdropClick: true, class: 'modal-dialog-centered animated bounceInRight' }));
  }

  notifyPanelToggle() {
    this.showNotifyPanel = !this.showNotifyPanel;
    if (this.showNotifyPanel) {
      this.loadNotifications();
    }
  }

  openNotification(item: any) {
    if (!item.isRead) {
      this.notificationService.markRead(item.id).subscribe(() => {
        item.isRead = true;
        this.notifyCount = Math.max(0, this.notifyCount - 1);
      });
    }

    const patientId = item.data?.patientId;
    this.showNotifyPanel = false;
    if (patientId) {
      this.router.navigate(['/patient-form'], { queryParams: { id: patientId } });
    }
  }
}
